<template>
  <v-dialog v-model="valueProxy" max-width="100vw" width="60%" @click:outside="$emit('close')">
    <v-card>
      <v-card-title class="justify-center">Package Usage Records</v-card-title>
      <v-card-subtitle> Product : {{ get(content, 'product.name', '-') }} </v-card-subtitle>
      <v-card-text>
        <div v-if="list.length > 0">
          <v-data-table
            :items-per-page="pageSize"
            :headers="headers"
            :items="list"
            hide-default-footer
            @reload="reload"
            disable-sort
          >
            <template v-slot:item.completedAt="{ item }">
              {{ moment(item.completedAt).format('DD/MM/YYYY hh:mm A') }}
            </template>
          </v-data-table>
        </div>
        <div v-else>
          <v-row>
            <v-col style="text-align: center">No Data</v-col>
          </v-row>
        </div>
        <v-pagination class="mt-4" v-model="pageVal" :length="data.pages || 1" />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { get } from 'lodash';
import { getUsageRecords } from '@/api/ticketPackage';
import api from '@/api';
import { getOid } from '@/services/utils';
import moment from 'moment';

export default {
  name: 'TicketUsageRecordsDialog',
  props: {
    show: Boolean,
    content: {},
  },
  data() {
    return {
      headers: [
        { text: 'Date', value: 'completedAt', width: '200px' },
        { text: 'Invoice', value: 'sid', width: '200px' },
        { text: 'remarks', value: 'remarks' },
      ],
      list: [],
      data: {},
      page: 1,
      pageSize: 10,
    };
  },
  computed: {
    valueProxy: {
      get() {
        return this.show;
      },
      set(v) {
        this.$emit('update:show', v);
        console.log({ v });
        if (v) {
          this.reload();
        }
      },
    },
    pageVal: {
      get() {
        return this.page;
      },
      set(val) {
        this.page = val;
        this.reload();
      },
    },
  },
  watch: {
    show(newValue, oldValue) {
      if (newValue) {
        this.list = [];
        this.reload();
      }
    },
  },
  methods: {
    get,
    moment,
    close() {
      this.$emit('close');
    },
    async reload() {
      this.data = await getUsageRecords(api, getOid(this.content), {
        page: this.page,
        limit: this.pageSize,

        sort: { completedAt: -1 },
      });
      this.list = this.data.docs;
    },
  },
};
</script>

<style scoped></style>
